<script lang="ts">
  import type { Api_Game } from '$lib/types/api/graphql';
  import { createEventDispatcher } from 'svelte';

  import Image from '$mds/Image';
  import FontAwesomeIcon from '$components/FontAwesomeIcon.svelte';
  import { faXmark } from '@fortawesome/pro-solid-svg-icons';

  const dispatch = createEventDispatcher();

  export let backgroundColor = 'bg-ondark-medium hover:bg-ondark-high';

  export let game: Api_Game;
</script>

<div
  class="flex items-center rounded-full py-2 pl-2 pr-6 text-xs font-medium text-white transition-colors {backgroundColor}"
>
  <Image
    src={game.logoMain?.original?.url || game.poster?.original?.url}
    rounded="rounded-full"
    class="h-5 w-5"
    sizes={{ xs: 20 }}
    alt={game.localizedTitles.en ?? ''}
  />

  <div class="my-0 cursor-default px-2.5 py-0 text-xs">
    {game.localizedTitles.en}
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click|stopPropagation={() => {
      dispatch('removeGame');
    }}
    class="rotate text-ondark-secondary absolute -right-1 flex h-11 w-11 cursor-pointer items-center justify-center"
  >
    <FontAwesomeIcon icon={faXmark} class="h-4 w-4" />
  </div>
</div>
